import { Box, Center } from '@chakra-ui/react';
import { useDetailedStatusGroupings, useApproveGrouping, useRejectGrouping } from 'hooks/queries/useGroupings';
import { ProcessStatus } from 'models/types';
import Slider from 'components/Slider/Slider';
import DetailedGroupingCard from 'components/Grouping/DetailedGroupingCard/DetailedGroupingCard';
import Loader from 'components/Loader/Loader';
import EmptyState from 'components/EmptyState/EmptyState';

export default function PendingGroupingsCarousel() {
  const { data: paginatedGroupings, isLoading } = useDetailedStatusGroupings(ProcessStatus.PENDING);
  const approveMutation = useApproveGrouping();
  const rejectMutation = useRejectGrouping();

  const handleApprove = (groupingId: string) => {
    approveMutation.mutate({ grouping_id: groupingId });
  };

  const handleReject = (groupingId: string) => {
    rejectMutation.mutate({ grouping_id: groupingId });
  };

  if (isLoading) {
    return (
      <Center p={8}>
        <Loader />
      </Center>
    );
  }

  if (!paginatedGroupings?.hasData()) {
    return (
      <Box width="100%">
        <EmptyState
          header="No Pending Groupings"
          description="There are no pending groupings at this time"
          showButton={false}
        />
      </Box>
    );
  }

  // Get up to 5 groupings for the carousel
  const groupings = paginatedGroupings.data.slice(0, 5);

  const carouselContent = groupings.map((grouping, index) => (
    <Box key={`pending_grouping_${grouping.id}_${index}`} px={2}>
      <DetailedGroupingCard
        grouping={grouping}
        onApprove={handleApprove}
        onReject={handleReject}
        approveLoading={approveMutation.isPending}
        rejectLoading={rejectMutation.isPending}
        defaultAccordionOpen={false}
      />
    </Box>
  ));

  return (
    <Box width="100%">
      <Slider
        content={carouselContent}
        slidesPerView={1}
        slidesPerMobileView={1}
        pagination={true}
        enableAutoPlay={false}
        itemPadding={0}
      />
    </Box>
  );
}
